/* eslint-disable import/no-default-export */
import React from 'react';

import Atom from './atom';
import DescriptionAtom from './description-atom';
import FeaturedAtom from './featured-atom';
import {
  AtomProps,
  DescriptionAtomProps,
  FeaturedAtomProps,
  PowerUpItemType,
} from './types';

export { PowerUpItemType } from './types';

export interface PowerUpProps {
  type: PowerUpItemType;
  atomProps: AtomProps | DescriptionAtomProps | FeaturedAtomProps;
}

export const PowerUp: React.FunctionComponent<PowerUpProps> = ({
  type,
  atomProps,
}) => {
  if (type === PowerUpItemType.Featured) {
    return <FeaturedAtom {...atomProps as FeaturedAtomProps} />;
  } else if (type === PowerUpItemType.Description) {
    return <DescriptionAtom {...atomProps as DescriptionAtomProps} />;
  }

  return <Atom {...atomProps} />;
};

export default PowerUp;



// WEBPACK FOOTER //
// ./app/common/components/power-up/index.tsx